module.exports = __webpack_public_path__ + "static/img/xwzx@2x.6ba0730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/xwzx@2x.png
// module id = stXl
// module chunks = 1